import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';
import { NavController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class TenantAuthGuard  {

  constructor(private authenticationService: AuthenticationService,
              private navController: NavController) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const result = new Subject<boolean>();
    this.authenticationService.isAuthenticated().subscribe(
      res => {
        if (res) {
          result.next(true);
          result.complete();
        } else {
          // this.authenticationService.removeToken();
          this.navController.navigateRoot('/launch');
          result.next(false);
          result.complete();
        }

      },
      error => {
        // this.authenticationService.removeToken();
        this.navController.navigateRoot('/launch');
        result.next(false);
        result.complete();
      }
    );
    return result.asObservable();

  }

}
